<template>
  <modal id="unlink-social-modal" :modifiers="['no-horizontal-padding']">
    <div class="unlink-social-modal">
      <h2 class="unlink-social-modal__headline">
        {{ $t("headline") }}
      </h2>
      <p class="unlink-social-modal__text">
        {{ noticeText }}
      </p>
      <div class="unlink-social-modal__footer">
        <a class="unlink-social-modal__cancel" @click="close">
          {{ $t("cancel") }}
        </a>
        <button class="unlink-social-modal__submit button" @click="submit">
          {{ $t("continue") }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/shared/modal"
import events from "@/bl-events/index"

/**
 * @emits submit
 */
export default {
  name: "UnlinkSocialModal",
  components: { Modal },
  props: { account: { type: Object, default: null } },
  computed: {
    noticeText() {
      if (this.account && this.account.type) {
        return this.$t(`noticeText.${this.account.type}`)
      } else {
        return ""
      }
    }
  },
  methods: {
    close() {
      events.emit("modal:unlink-social-modal:close")
    },
    submit() {
      this.close()
      this.$emit("submit", this.account)
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "This action can’t be undone",
        noticeText: {
          apple:
            'We will remove "Sign in with Apple" from your Blinkist account and you will be able to log in with your email address and password only.',
          facebook:
            'We will remove "Sign in with Facebook" from your Blinkist account and you will be able to log in with your email address and password only.'
        },
        cancel: "Cancel",
        continue: "Continue"
      },
      de: {
        headline: "Bist du sicher?",
        noticeText: {
          apple:
            '"Mit Apple anmelden" wird nun von deinem Blinkist-Konto entfernt und du kannst dich nur noch mit deiner E-Mail-Adresse und deinem Passwort einloggen.\nDies kann nicht rückgängig gemacht werden.',
          facebook:
            '"Mit Facebook anmelden" wird nun von deinem Blinkist-Konto entfernt und du kannst dich nur noch mit deiner E-Mail-Adresse und deinem Passwort einloggen.\nDies kann nicht rückgängig gemacht werden.'
        },
        cancel: "Abbrechen",
        continue: "Entfernen"
      }
    }
  }
}
</script>

<style lang="scss">
.unlink-social-modal {
  width: 100vw;
  max-width: $x-wide-block-width;
  padding: $spacing-48 $spacing-24 $spacing-24;

  &__headline {
    @include font-style(h3);

    margin-bottom: $spacing-24;
  }

  &__text {
    @include font-style(p);

    margin-top: $spacing-24;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  &__submit {
    min-width: spacing(118px);
  }

  &__cancel {
    @include font-style(button, $color: $mid-grey);

    margin-right: $base;

    cursor: pointer;
  }

  @include media(min-width, m) {
    width: $x-wide-block-width;
  }
}
</style>
